import styled from "styled-components";
import {BOX_BORDER_RADIUS_PX} from "../css-global-constants";

export const PrimaryButtonBox = styled.button`
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primaryContrast};
    border-radius: ${BOX_BORDER_RADIUS_PX};
    font-size: ${props => props.theme.fontSize.large};
    border: none;
    box-shadow: none;
    cursor: pointer;
`
